var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      staticClass: "container-schedule installation",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("h3", { staticClass: "stepper__title gray" }, [
        _vm._v("Contacto para la instalación")
      ]),
      _c(
        "div",
        { staticClass: "schedule__form" },
        [
          _c(
            "v-flex",
            { staticClass: "checkbox__centered" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", "fill-height": "" } },
                [
                  _c("v-checkbox", {
                    attrs: { "input-value": "true", color: "orange" },
                    on: { change: _vm.loadLegalRepresentativeData },
                    model: {
                      value: _vm.dataLegal,
                      callback: function($$v) {
                        _vm.dataLegal = $$v
                      },
                      expression: "dataLegal"
                    }
                  }),
                  _c("h4", [_vm._v("Utilizar datos del representante legal")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm12: "" } },
            [
              _c("v-text-field", {
                staticClass: "style-stepped my-21px",
                attrs: {
                  label: "Nombres",
                  name: "name",
                  "error-messages": _vm.nameErrorMessage,
                  disabled: _vm.sending,
                  maxlength: 40
                },
                on: {
                  input: function($event) {
                    _vm.$v.name.$touch()
                  },
                  keypress: _vm.onlyLetters,
                  blur: function($event) {
                    _vm.$v.name.$touch()
                  }
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "name"
                }
              }),
              _c("v-text-field", {
                staticClass: "style-stepped my-21px",
                attrs: {
                  label: "Apellido paterno",
                  "error-messages": _vm.paternalLastnameErrorMessage,
                  disabled: _vm.sending,
                  maxlength: 40
                },
                on: {
                  input: function($event) {
                    _vm.$v.paternalLastname.$touch()
                  },
                  keypress: _vm.onlyLetters,
                  blur: function($event) {
                    _vm.$v.paternalLastname.$touch()
                  }
                },
                model: {
                  value: _vm.paternalLastname,
                  callback: function($$v) {
                    _vm.paternalLastname =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "paternalLastname"
                }
              }),
              _c("v-text-field", {
                staticClass: "style-stepped my-21px",
                attrs: {
                  label: "Apellido materno",
                  "error-messages": _vm.maternalLastnameErrorMessage,
                  disabled: _vm.sending,
                  maxlength: 40
                },
                on: {
                  input: function($event) {
                    _vm.$v.maternalLastname.$touch()
                  },
                  keypress: _vm.onlyLetters,
                  blur: function($event) {
                    _vm.$v.maternalLastname.$touch()
                  }
                },
                model: {
                  value: _vm.maternalLastname,
                  callback: function($$v) {
                    _vm.maternalLastname =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "maternalLastname"
                }
              }),
              _c("v-text-field", {
                staticClass: "style-stepped my-21px",
                attrs: {
                  label: "Teléfono de contacto",
                  name: "number",
                  "error-messages": _vm.contactErrorMessage,
                  disabled: _vm.sending,
                  maxLength: 9
                },
                on: {
                  input: function($event) {
                    _vm.$v.number.$touch()
                  },
                  keypress: _vm.onlyNumbers,
                  blur: function($event) {
                    _vm.$v.number.$touch()
                  }
                },
                model: {
                  value: _vm.number,
                  callback: function($$v) {
                    _vm.number = $$v
                  },
                  expression: "number"
                }
              }),
              _c("email-autocomplete", {
                staticClass: "style-stepped my-21px",
                attrs: {
                  label: "Correo",
                  stepper: true,
                  "error-messages": _vm.emailErrorMessage,
                  withErrors: true,
                  disabled: _vm.sending,
                  maxlength: 40
                },
                on: {
                  input: function($event) {
                    _vm.$v.email.$touch()
                  },
                  blur: function($event) {
                    _vm.$v.email.$touch()
                  }
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "button-container installation" },
        [
          _c(
            "v-btn",
            {
              staticClass: "primary-button",
              attrs: {
                small: "",
                disabled: _vm.sending || _vm.$v.$invalid,
                type: "submit"
              }
            },
            [_vm._v("Continuar")]
          ),
          !_vm.$isCorresponsalia()
            ? _c(
                "v-btn",
                {
                  staticClass: "primary-button text black capitalize",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      _vm.changeStep(false)
                    }
                  }
                },
                [_vm._v("Atrás")]
              )
            : _vm._e(),
          _vm.$isCorresponsalia()
            ? _c(
                "v-btn",
                {
                  staticClass: "primary-button text black capitalize",
                  attrs: { small: "" },
                  on: {
                    click: function($event) {
                      _vm.back()
                    }
                  }
                },
                [_vm._v("Atrás")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("loader", {
        ref: "loaderModal",
        attrs: { text: "Realizando validación" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-535e6e2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-535e6e2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/installation-schedule.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-535e6e2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/installation-schedule.vue
// module chunks = 0 1 2 3